import { render } from "./WechatConnect.vue?vue&type=template&id=9368dc28"
import script from "./WechatConnect.vue?vue&type=script&lang=js"
export * from "./WechatConnect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__